import Awesomplete from 'awesomplete';
import 'awesomplete/awesomplete.css';

export default function SearchProducts() {
  const input = document.querySelector("#q");
  if (!input) return;

  let searchTimeout = null;

  const awesomplete = new Awesomplete(input, {
    minChars: 2,
    maxItems: 15,
    autoFirst: true
  });

  input.addEventListener("input", function () {
    clearTimeout(searchTimeout);

    searchTimeout = setTimeout(() => {
      if (input.value.length < 2) return;

      const distributorId = input.dataset.distributor;
      if (!distributorId) return;

      fetch(`/api/products/search/${distributorId}?query=${encodeURIComponent(input.value)}`)
        .then(response => response.json())
        .then(data => {
          awesomplete.list = data.data.map(item => ({
            label: item.name,
            value: item.id
          }));
        });
    }, 400);
  });

  input.addEventListener("awesomplete-selectcomplete", function (event) {
    input.value = event.text.label;
    input.form.submit();
  });
}
